<template>
  <div class="overseas-cert-container">
    <h1 class="main-title">非中国大陆经营者和法定代表人证件说明</h1>
    <h2 class="sub-lead-title">暂时支持持有以下证件的商家入驻</h2>

    <!-- 1.中国香港和中国澳门 -->
    <section class="cert-section">
      <h3 class="region-title">1.中国香港和中国澳门</h3>

      <div class="cert-item">
        <h4 class="cert-name">（1）港澳居民来往内地通行证</h4>
        <div class="sample-tip">*示例</div>
        <div class="img-box">
          <img
            :src="hkMoPermitImg"
            class="sample-img img-hk-mo"
            alt="港澳居民来往内地通行证示例"
          />
        </div>
      </div>
    </section>

    <!-- 2.中国台湾 -->
    <section class="cert-section">
      <h3 class="region-title">2.中国台湾</h3>

      <div class="cert-item">
        <h4 class="cert-name">（1）台湾居民来往大陆通行证（新版）</h4>
        <div class="sample-tip">*示例</div>
        <div class="img-box">
          <img
            :src="twPermitNewImg"
            class="sample-img img-tw-new"
            alt="台湾居民来往大陆通行证（新版）示例"
          />
        </div>
      </div>

      <div class="cert-item">
        <h4 class="cert-name">（2）台湾居民来往大陆通行证（旧版）</h4>
        <div class="sample-tip">*示例</div>
        <div class="img-box">
          <img
            :src="twPermitOldImg"
            class="sample-img img-tw-old"
            alt="台湾居民来往大陆通行证（旧版）示例"
          />
        </div>
      </div>
    </section>

    <!-- 3.护照 -->
    <section class="cert-section">
      <h3 class="region-title">3.护照</h3>

      <div class="cert-item">
        <h4 class="cert-name">（1）护照</h4>
        <div class="sample-tip">*示例</div>
        <div class="img-box">
          <img
            :src="passportImg"
            class="sample-img img-passport"
            alt="护照示例"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "OverseasCertificate",
  data() {
    return {
      hkMoPermitImg: require("@/assets/img/apply/cert/hk_mo_permit.png"),
      twPermitNewImg: require("@/assets/img/apply/cert/tw_permit_new.png"),
      twPermitOldImg: require("@/assets/img/apply/cert/tw_permit_old.png"),
      passportImg: require("@/assets/img/apply/cert/passport.png")
    };
  }
};
</script>

<style lang="less" scoped>
.overseas-cert-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 20px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .sub-lead-title {
    margin: 0 0 28px 0;
    font-size: 20px;
    font-weight: 600;
    color: #262626;
    line-height: 1.4;
  }

  .cert-section {
    margin-bottom: 36px;

    .region-title {
      margin: 0 0 16px 0;
      font-size: 18px;
      font-weight: 600;
      color: #1f1f1f;
      line-height: 1.4;
    }

    .cert-item {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      .cert-name {
        margin: 0 0 8px 0;
        font-size: 15px;
        font-weight: 600;
        color: #262626;
        line-height: 1.5;
      }

      .sample-tip {
        font-size: 13px;
        color: #595959;
        margin-bottom: 12px;
      }

      .img-box {
        margin-top: 8px;

        .sample-img {
          display: block;
          max-width: 100%;
          height: auto;
          border-radius: 4px;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
          border: 1px solid #f0f0f0;
        }

        .img-hk-mo {
          width: 418px;
        }

        .img-tw-new {
          width: 404px;
        }

        .img-tw-old {
          width: 236px;
        }

        .img-passport {
          width: 239px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .overseas-cert-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 16px;
    }

    .sub-lead-title {
      font-size: 17px;
      margin-bottom: 20px;
    }

    .cert-section {
      margin-bottom: 28px;

      .region-title {
        font-size: 16px;
      }

      .cert-item {
        .img-box {
          .img-hk-mo,
          .img-tw-new,
          .img-tw-old,
          .img-passport {
            width: 100%;
            max-width: 418px;
          }
        }
      }
    }
  }
}
</style>
